import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { HeaderDialogComponent } from "../header-dialog/header-dialog.component";
import { SharedModule } from "../../../shared.module";
import { ExcelExportButtonComponent } from "../../../components/excel-export-button/excel-export-button.component";

/**
 * Header de dialog avec titre + bouton d'export Excel. Utilisé par les dialogs
 * "Voir tout" des widgets statistiques (vente-evolution, ca-par-periode,
 * repartition-ca, etc.). Le titre est projeté via <ng-content>, ce qui permet
 * d'y ajouter librement du texte, des chips ou des badges contextuels.
 */
@Component({
  selector: "vl-dialog-header-export",
  standalone: true,
  imports: [
    CommonModule,
    SharedModule,
    HeaderDialogComponent,
    ExcelExportButtonComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./dialog-header-export.component.html",
})
export class DialogHeaderExportComponent {
  exporting = input<boolean, unknown>(false, { transform: booleanAttribute });
  exportTooltipKey = input<string>("dashboard_ui.export_excel");

  close = output<void>();
  export = output<void>();
}
